import styled from "styled-components";

export const Title = styled.h2`
    color: #122661;
    font-size: 25px;
    text-transform: uppercase;
    letter-spacing: 5px;
    text-align: center;
    overflow-wrap: break-word;
`